<template>
    <div class="field-wrapper" :class="showError() ? 'field-wrapper--error' : ''">
        <label :for="inputId" class="field-label" :class="isFocused || localValue != '' ? 'field-label--up' : ''">
            {{ fieldLabel }}<span v-if="required" class="text-red-default">&nbsp;*</span>
        </label>
        <div class="flex items-center" :class="showError() ? 'mb-2' : ''">
            <ChevronDown class="absolute right-4 pointer-events-none field-select-arrow" />
            <select
                name=""
                ref="select"
                class="field-input appearance-none cursor-pointer bg-white"
                :id="inputId"
                :value="localValue"
                :required="required"
                :disabled="disabled"
                @blur="onBlur"
                @focus="onFocus"
                @change="updateInput($event.target.value)"
            >
                <option value="" disabled hidden></option>
                <option v-for="option in options" :value="option.value" :key="option.value">{{ option.label }}</option>
            </select>
        </div>
        <div class="text-red-default text-xs" v-if="showError() && $slots.error" aria-live="polite">
            <slot name="error"></slot>
        </div>
    </div>
</template>

<script>
import ChevronDown from '@/../svg/chevron-down.svg?component';

export default {
    components: {
        ChevronDown,
    },
    data() {
        return {
            isFocused: false,
            localValue: '',
            dirty: false,
        };
    },
    props: {
        fieldLabel: String,
        required: Boolean,
        valid: Boolean,
        value: String,
        options: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onBlur() {
            this.isFocused = false;
            this.dirty = true;
        },
        onFocus() {
            this.isFocused = true;
        },
        updateInput(value) {
            this.localValue = value;
            this.dirty = true;
            this.$emit('update:modelValue', this.localValue);
        },
        showError() {
            return this.dirty && !this.valid;
        },
    },
    created() {
        this.localValue = this.value || '';
    },
    computed: {
        inputId() {
            return `select-${Math.random().toString(36).slice(2, 10)}`;
        },
    },
    watch: {
        value(newVal) {
            this.localValue = newVal || '';
        },
    },
};
</script>
